import { Link } from 'react-router-dom';
import LegalDocumentView from '../components/LegalDocumentView';
import { useLegalDocument } from '../hooks/useLegalDocument';

/**
 * The Data Privacy Policy, as edited by a Super Admin.
 *
 * Public on purpose: someone deciding whether to hand over an ID number
 * and a household income figure has to be able to read this before
 * registering, not after.
 */
const PrivacyPolicyPage = () => {
  const { content, loading } = useLegalDocument('privacy');

  return (
    <div className="container" style={{ maxWidth: '48rem', padding: '2rem 1rem 4rem' }}>
      <Link to="/" style={{ fontSize: '0.9rem' }}>
        &larr; Back to the home page
      </Link>

      {loading ? <p style={{ marginTop: '2rem' }}>Loading...</p> : <LegalDocumentView content={content!} />}

      <p style={{ marginTop: '2.5rem', fontSize: '0.9rem' }}>
        See also the <Link to="/terms">Terms and Conditions</Link>.
      </p>
    </div>
  );
};

export default PrivacyPolicyPage;
